module.exports = __webpack_public_path__ + "static/media/app-screen-04.59adab28.jpg";